import { useEffect } from "react";

import { useLazyQuery } from "@apollo/client";

import { GET_DEVICES_BY_LOCATION } from "../../../../../common/operations/queries";
import { errorNotification } from "../../../../../common/variables/notification";
import client from "../../../../../configs/apolloClient";
import type {
  GetDevicesByLocationQuery,
  GetDevicesByLocationQueryVariables,
} from "../../../../../API";

export const DEVICES_TABLE_LIMIT = 100;

export const useGetDevicesByLocation = (locationId: string) => {
  useEffect(() => {
    if (locationId && locationId !== "") {
      fetchDevices(locationId);
    }
  }, [locationId]);

  const handleRequestError = () => {
    client.cache
      .reset()
      .then(() => {
        errorNotification();
      })
      .catch(error => {
        console.error(error);
      });
  };

  const [getDevicesByLocation, { data, loading }] = useLazyQuery<
    GetDevicesByLocationQuery,
    GetDevicesByLocationQueryVariables
  >(GET_DEVICES_BY_LOCATION, {
    fetchPolicy: "network-only",
  });

  const fetchDevices = (locationId?: string | null, nextToken?: string) => {
    getDevicesByLocation({
      variables: {
        locationId: locationId ?? "",
        nextToken,
      },
    })
      .then(response => {
        if (response?.data?.getDevicesByLocation?.nextToken) {
          fetchDevices(
            locationId,
            response.data?.getDevicesByLocation.nextToken
          );
        }

        if (response.error) {
          handleRequestError();
        }
      })
      .catch(e => {
        console.error(e);

        handleRequestError();
      });
  };

  const refetchDevices = (locationId: string) => {
    fetchDevices(locationId);
  };

  return { data, loading, refetchDevices };
};
